"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNamespace = void 0;
exports.getNamespace = function (input) {
    switch (input) {
        case 'LOGINUI':
            return 'LOGINUI';
        case 'APPSHELL':
            return 'appShell';
        default:
            return 'LOGINUI';
    }
};
//# sourceMappingURL=localdatastore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/api/localdatastore.js
// module id = 350
// module chunks = 8